import React, {useEffect, useState} from "react";
import {ErrorToast, SuccessToast} from "../../shared/toasters/toasters";
import {AdminJobService} from "./service";
import {useTranslation} from "react-i18next";
import DraggableBootstrapTable from "../../shared/components/draggableList/Draggable";
import {Pagination} from "../../shared/paginations/Paginations";
import {IJob} from "./interface";
import {ConfirmDelete} from "../../shared/components/ConfirmDelete";
import {useNavigate} from "react-router-dom";
import List from "./components/List";

export const AdminJob = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 25,
        term: ""
    });
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const [selectedPrompt, setSelectedPrompt] = useState<IJob | null>(null);
    const [list, setList] = useState<IJob[]>([]);
    const handlePages = (updatePage: number) => {
        setPagination({...pagination, page: updatePage});
        setPage(updatePage);
    };
    const updatePosition = (newList: IJob[]) => {
        const newListUpdated = newList?.map((item) => item.id) as number[];
        AdminJobService.updatePosition(newListUpdated);
    };
    const editHandler = (id: number): void => {
        navigate(`/admin/job/update/${id}`);
    };
    const deleteHandler = () => {
        selectedPrompt?.id &&
        AdminJobService.delete(selectedPrompt?.id)
            .then((response) => {
                if (response?.status === "success") {
                    SuccessToast(t(`jobs.successfully_deleted`));
                    setPagination((prev) => ({...prev, updatedAt: new Date().getTime()}))
                }
            })
            .catch(ErrorToast);
    };
    useEffect(() => {
        AdminJobService.getAll(pagination)
            .then((response) => {
                const {data} = response;
                setList(data?.items);
                setTotalPages(Math.ceil(data?.totalItems / data?.perPage));
            })
            .catch(ErrorToast);
    }, [pagination]);
    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="card-body d-flex align-items-center ">
                        <div className="d-flex align-items-center gap-3">
                            <div className="search-box">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="searchMemberList"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setPagination((prev) => ({
                                            ...prev,
                                            page: 1,
                                            term: e.target.value,
                                        }))
                                    }
                                    placeholder={t("global.search")}
                                />
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                        <button className="btn btn-primary ms-auto"
                                onClick={() => navigate("/admin/job/create")}>
                            {t("global.add")}
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-12">
                {page > 1 || pagination?.term ? (
                    <List list={list}
                          editHandler={editHandler}
                          setShow={setShow}
                          setSelectedPrompt={setSelectedPrompt}
                    />
                ) : (
                    <DraggableBootstrapTable
                        preview={true}
                        list={list!}
                        setList={setList}
                        headers={["id", "title", "date", "active"]}
                        title="jobs"
                        onEdit={editHandler}
                        selectedPrompt={selectedPrompt}
                        setSelectedPrompt={setSelectedPrompt}
                        handleShow={handleShow}
                        show={show}
                        setShow={setShow}
                        deleteHandler={deleteHandler}
                        updatePosition={updatePosition}
                    />
                )}
                {page && (
                    <div className="d-flex justify-content-end">
                        {totalPages <= 1 ? (
                            ""
                        ) : (
                            <Pagination
                                page={page}
                                totalPages={totalPages}
                                handlePagination={handlePages}
                            />
                        )}
                    </div>
                )}
            </div>

            <ConfirmDelete
                show={show}
                setShow={setShow}
                itemName={selectedPrompt?.title}
                deleteHandler={deleteHandler}
                selectedProduct={selectedPrompt}
            />
        </>
    );
};
